module.exports = __webpack_public_path__ + "static/btn 2_00006.bd2dd2f5.png";